<template>
  <div :style="{ backgroundColor: $finColors.primaryLight }">
    <h2 v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
        v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
        class="pt-7 pb-3">
      Passende <span v-if="assetClassId === 'SHARE'">Aktien</span><span v-else>ETFs</span>
    </h2>

    <div v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <fin-strategy-instruments-data-table :asset-class-id="assetClassId"
                                           :extended-view="extendedView"
                                           :show-instrument-profile-as="noInstrumentLink ? undefined : 'link'"
                                           :strategy="strategy"
                                           :table-height="$vuetify.breakpoint.smAndDown ? '65vh':'55vh'"
                                           realtime/>
    </div>
  </div>
</template>

<script>
import FinStrategyInstrumentsDataTable from "@/components/common/StrategyInstrumentsDataTable"

export default {
  name: "fin-strategy-details-instruments",
  components: {
    FinStrategyInstrumentsDataTable
  },
  props: {
    strategy: {
      type: Object
    },
    assetClassId: {
      type: String
    },
    /** In the data table do not link the instruments to the profile page. Needed because of onboarding */
    noInstrumentLink: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      extendedView: false
    }
  }
}
</script>

<style lang="scss" scoped>

h2 {
  font-family: $body-font-family;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark
}

</style>
